export const data = [{
    id1: 1,
    Profile1: <img src="https://www.pembrokehouse.org.uk/wp-content/uploads/2020/06/Pembroke-House-Rachel-Elizabeth-Photography-30_scaled_3-scaled.jpg" width={60}></img>,
    Name1: "Hub003",
    Center_for: "9156781403",
    location1: "  15, Plot No 18, Twinkle Apartment, Adjoining Link Road, Andheri (west) ,Mumbai 400001 ",
    bdss:" Mumbai",
    lm:"31 mins ago",
    url:"http://localhost:3000/Hospital/bedg"
  }, {

    id1: 2,
    Profile1: <img src="https://www.shrewsburyfoodhub.org.uk/wp-content/uploads/2022/12/Jane-from-Aico-Ali.jpg" width={60}></img>,
    Name1: "Hub040",
    Center_for: "9123568902",
    location1: "S V P Road,  Vyapar Sadan West, Bangalore 560103",
    bdss:"Bangalore",
    lm:"35 mins ago",
    url:"http://localhost:3000/Hospital/bedg"
  }, {
    id1: 3,
    Profile1: <img src="https://cdn.shopify.com/s/files/1/0402/9077/9285/files/AmpersandGrey-ThePublic-265.jpg?v=1661284523&width=480" width={60}></img>,
    Name1: " Hub001",
    Center_for: "9123612729",
    location1: " 1, Fulchand Niwas, S.v.patel Road, Grant Road, Maharashtra 400053",
    bdss:"Mumbai",
    lm:"40 mins ago",
    url:"http://localhost:3000/Hospital/bedg"
  }, {
    id1: 4,
    Profile1: <img src="https://cdn.shopify.com/s/files/1/0402/9077/9285/files/A6A9CFDF-F70F-4C0E-89EC-4D92CD8803E4_1_201_a.jpg?v=1661284847&width=480" width={70}></img>,
    Name1: "hub076",
    Center_for: " 9122202833",
    location1: "33, 3rd Floor, Bvk Iyengar Road, Bangalore 560053",
    bdss:"Bangalore",
    lm:"1 hr ago",
    url:"http://localhost:3000/Hospital/bedg"
  }, {
    id1: 5,
    Profile1: <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTcBPwb3MaNYu2EtGao09DRocH8tp6N2PRO-xHbWytn_6OZi8WVdWOFsgyND55z4KEqAp4&usqp=CAU" width={70}></img>,
    Name1: " Hub006",
    Center_for: " 915587129870",
    location1: " Rz 5 74/1/28, Rajdhani Park, Rohtak Rd, Delhi 110041",
    bdss:"Delhi",
    lm:"5 mins ago",
    url:"http://localhost:3000/Hospital/bedg"
  }, {
    id1: 6,
    Profile1: <img src="https://image.jimcdn.com/app/cms/image/transf/dimension=940x10000:format=jpg/path/s572b1f254a744cf5/image/i5195f340c6693386/version/1626814790/image.jpg" width={60}></img>,
    Name1: "HUb007",
    Center_for: " 02024454973",
    location1: "Shop-11,rashtbhushan Chk, Swargate Maharashtra 411042 ",
    bdss:"Pune",
    lm:"2 hrs ago",
    url:"http://localhost:3000/Hospital/bedg"
  }, {
    id1: 7,
    Profile1: <img src="https://image.jimcdn.com/app/cms/image/transf/dimension=375x1024:format=jpg/path/s572b1f254a744cf5/image/ie55ddf019dcc361f/version/1626872456/image.jpg" width={60}></img>,
    Name1: "Hub034",
    Center_for: " 9123654781",
    location1: " 2, Rawdon St, Mullick Bazar, Park Street area, Kolkata, West Bengal 700017",
    bdss:"Kolkata",
    lm:"12 mins ago",
    url:"http://localhost:3000/Hospital/bedg"
  }, {
    id1: 8,
    Profile1: <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSgKVGxRU-2HFJKaL9FAR3T4woF0sQFNfst0vg70S8AyijQ4RffCOgCjIl_a1iqiFuxDVY&usqp=CAU" width={60}></img>,
    Name1: "Hub055",
    Center_for: " 9185236970",
    location1: "7, 2, Diamond Harbour Rd, New Alipore, Kolkata, West Bengal 700027",
    bdss:"Kolkata",
    lm:"31 mins ago",
    url:"http://localhost:3000/Hospital/bedg"
  }, {
    id1: 9,
    Profile1: <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSn8XUTyj05zbVafZSoIWDNgL8afDAzb2ncZw&usqp=CAU" width={60} height={70}></img>,
    Name1: "Hub077",
    Center_for: " 9123578940",
    location1: " 9, Dr U. N. Brahmachari Street (Formerly Loudon Street), Elgin, Kolkata, West Bengal 700017",
    bdss:"Kolkata",
    lm:"56 mins ago",
    url:"http://localhost:3000/Hospital/bedg"
  }, {
    id1: 10,
    Profile1: <img src="https://www.foodmanufacture.co.uk/var/wrbm_gb_food_pharma/storage/images/publications/food-beverage-nutrition/foodmanufacture.co.uk/expertise/operations/plans-submitted-for-21m-scottish-food-hub/12187352-1-eng-GB/Plans-submitted-for-21m-Scottish-food-hub.jpg" width={60}></img>,
    Name1: "Hub009",
    Center_for: "9711939386",
    location1: "SCO-165, 2nd Floor Commercial Center, Vyapar Sadan, Opp Govt Girls College, MG Road, Sector-14",
    bdss:"Gurgaon",
    lm:"1 hr ago",
    url:"http://localhost:3000/Hospital/bedg"
  },
  {
    id1: 1,
    Profile1: <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSbJZM0b71w-wuwQtIWSc7YnHcrqWp1MJ_ZOCkGlHjD4qYlfiYPL9nSOXasRXHViBqmkmE&usqp=CAU" width={60}></img>,
    Name1: "Hub003",
    Center_for: "9156781403",
    location1: "  15, Plot No 18, Twinkle Apartment, Adjoining Link Road, Andheri (west) ,Mumbai 400001 ",
    bdss:" Mumbai",
    lm:"31 mins ago",
    url:"http://localhost:3000/Hospital/bedg"
  }
];